export const standardizeDateFormat = (dateInput, includeTime = false) => {
  let dateString = dateInput;

  // 1. If the database sends a raw time '05:39' without a 'Z' or '+', 
  // we force it to be treated as UTC so the browser converts it to IST.
  if (dateString && typeof dateString === 'string' && !dateString.endsWith('Z') && !dateString.includes('+')) {
    dateString = dateString.replace(' ', 'T') + 'Z';
  }

  const date = new Date(dateString);

  // 2. Safety check: If the date is invalid, just return the raw input
  if (isNaN(date.getTime())) {
    return dateInput;
  }
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();
  // Array of month names
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  // Function to get the ordinal suffix for a given day
  function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th'; // 4-20 is always 'th'
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  // Get the ordinal suffix for the day
  const dayWithSuffix = day + getOrdinalSuffix(day);

  // Get the month name from the array
  const monthName = monthNames[monthIndex];

  // Initialize the formatted date string
  let formattedDate = `${dayWithSuffix} ${monthName} ${year}`;

  if (includeTime) {
    // 3. These methods (getHours/getMinutes) naturally use your local India time (IST)
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    formattedDate += ` at ${formattedTime}`;
  }

  // Return the formatted date string
  return formattedDate;
}

